import { useCallback, useContext, useMemo, useState } from "react";

import { AppearanceContext } from "../context/AppearanceContext";

import {
  appearanceThemes,
  appearanceColorSchemes,
  appearanceContrastModes,
} from "../data";

const useAppearance = () => {
  /*
   * ------------------------------------------------------------------
   * Context
   * ------------------------------------------------------------------
   */

  const {
    theme,
    colorScheme,
    contrastMode,

    setTheme,
    setColorScheme,
    setContrastMode,
  } = useContext(AppearanceContext);

  /*
   * ------------------------------------------------------------------
   * Dropdown
   * ------------------------------------------------------------------
   */

  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  /*
   * ------------------------------------------------------------------
   * API
   * ------------------------------------------------------------------
   */

  return useMemo(
    () => ({
      isOpen,

      open,
      close,
      toggle,

      theme,
      colorScheme,
      contrastMode,

      setTheme,
      setColorScheme,
      setContrastMode,

      themes: appearanceThemes,
      colorSchemes: appearanceColorSchemes,
      contrastModes: appearanceContrastModes,
    }),
    [
      isOpen,

      theme,
      colorScheme,
      contrastMode,

      open,
      close,
      toggle,

      setTheme,
      setColorScheme,
      setContrastMode,
    ]
  );
};

export default useAppearance;